// InvestInThink5Whys.jsx
import React from 'react';
import MainLayout from '../layouts/MainLayout';
import '../styles/AboutUs.css';

const InvestInThink5Whys = () => {
  return (
    <MainLayout>
      <div className='text-lg mt-12 text-white'>
        <h2 class="text-2xl font-bold text-center text-yellow-200 mb-6">Invest Early in Think5Whys</h2>
        <h1 class="text-xl font-bold text-center text-yellow-200 mb-6">
            Invest in Think5Whys: A Global Platform for Learning, Productivity, Deep Thinking, and Self-Improvement
        </h1>

        <div class="text-lg mb-6">
            <p className='text-gray-100'>
                Think5Whys is not just another educational platform—it's a <strong>revolutionary ecosystem</strong> aimed at unlocking human potential on multiple levels. Our platform is designed to cater to the <strong>6 billion+ potential users worldwide</strong> and <strong>40 million+ MSMEs</strong> that seek not only learning but also productivity, deep thinking, and self-improvement.
            </p>
        </div>

        <div class="bg-gray-500 text-white p-6 rounded-lg mb-6">
            <h2 class="text-xl font-bold text-yellow-200  mb-4">What We’re Offering to Investors</h2>
            <p className='text-gray-100'>
                We are looking for <strong>5-10 forward-thinking investors</strong> to partner with us by investing <strong>₹5-10 lakh</strong> each. Here’s how we plan to deliver value:
            </p>
            <ul class="list-disc list-inside ml-4">
                <li><strong>Revenue Share Model:</strong> Investors will get their investment back through our unique referral-driven sales model.</li>
                <li><strong>Direct Referral Goal:</strong> Your referral code will remain visible until you reach <strong>3,030 direct customers</strong> with an <strong>Average Revenue Per User (ARPU) of ₹750</strong>.</li>
                <li><strong>Multilevel Income:</strong> Continue earning passive income through our <strong>multilevel marketing system up to Level 8</strong>.</li>
                <li><strong>Projected Earnings:</strong> Potentially earn <strong>₹25 lakh or more</strong> in the coming months as your referral network grows.</li>
            </ul>
        </div>

        <div class="p-6 mb-6">
            <h2 class="text-xl font-bold text-yellow-200 mb-4">Why Invest in Think5Whys?</h2>
            <ul class="list-disc list-inside ml-4">
                <li><strong>A Comprehensive Ecosystem:</strong> Think5Whys is about more than learning—it's about <strong>productivity, deep thinking, and self-improvement</strong>, with tools that foster holistic growth.</li>
                <li><strong>Massive Potential Audience:</strong> With over <strong>6 billion potential users worldwide</strong> and <strong>40 million MSMEs</strong>, Think5Whys is positioned for massive scalability.</li>
                <li><strong>Innovative Approach:</strong> Our platform goes beyond traditional education, offering <strong>deep thinking, problem-solving, and self-improvement</strong> tools.</li>
            </ul>
        </div>

        <div class="bg-blue-500 text-white p-6 rounded-lg mb-6">
            <h2 class="text-xl font-bold text-yellow-200 mb-4">What You Get as an Investor</h2>
            <ul class="list-disc list-inside ml-4">
                <li><strong>Initial Returns from Referral Sales:</strong> Your investment will be returned through sales driven by your referral code.</li>
                <li><strong>Passive Income:</strong> Continue earning income through <strong>indirect referrals at multiple levels</strong>.</li>
                <li><strong>Complete Support:</strong> We handle promotions, marketing, and customer onboarding, making this a <strong>hassle-free investment</strong> for you.</li>
            </ul>
        </div>

        <div class="p-6 mb-6">
            <h2 class="text-xl font-bold text-yellow-200 mb-4">Expected Timeframe</h2>
            <ul class="list-disc list-inside ml-4">
                <li>Investors can start seeing returns <strong>immediately</strong> as referral sales begin.</li>
                <li>Achieving <strong>3,030 referrals</strong> can happen within a few months, after which Level 8 multilevel income will continue to grow.</li>
            </ul>
        </div>

        <div class="bg-gray-500 text-white p-6 rounded-lg">
            <h2 class="text-2xl font-bold text-yellow-200 mb-4">Join Think5Whys as an Investor Today!</h2>
            <p className='text-gray-100'>
                Think5Whys is building a global community focused on <strong>self-improvement, productivity, and deeper thinking</strong>, offering cutting-edge tools for both individuals and businesses. As our platform grows, so do the opportunities for investors like you. Don’t miss out on this chance to invest in a rapidly expanding, <strong>multifaceted platform</strong>!
            </p>
        </div>
        <div class="bg-gray-500 text-white p-6 rounded-lg">
            <h2 class="text-2xl font-bold text-yellow-200 mb-4">Existing Investment</h2>
            <p className='text-gray-100'>
              "Over ₹1,50,00,000 invested in building the platform, ₹25,00,000 in content royalties as sweat equity, and ₹5,00,000+ from investors."
            </p>
        </div>
        <div class="bg-gray-500 text-white p-6 rounded-lg">
            <h2 class="text-2xl font-bold text-yellow-200 mb-4">Thanks & looking forward to connect with you</h2>
            <p className='text-gray-100'>
                Sanjeev Kumar<br/>
                Founder & Architect of Thinks5Whys<br/>
                Email: sanjeev@think5whys.com
                WhatsApp: +91 9324342890
            </p>
            <p className='text-gray-100'>
                Babita Sinha<br/>
                Co-Founder & Chief Women Empowerment Office<br/>
                Email: babita@think5whys.com
                WhatsApp: +91 xxxxxx xxxxx
            </p>
        </div>
      </div>

    </MainLayout>
  );
};

export default InvestInThink5Whys;
